<div *ngIf="isLoaded()" (mouseleave)="expTooltip.hide($event)">
    <p-overlayPanel #expTooltip appendTo="body" showTransitionOptions="300ms 1100ms ease-out"
        [style]="{ 'max-width': '40%'}">
        <dl class="row">
            <!-- Descripción expediente -->
            <dt class="col-5">{{dossierType && dossierType === 'CONTRACTS'? ('DossiersView.id.CONTRACTS' |translate):
                ('DossierBasicInfo.id.dossier' | translate)}}
            </dt>
            <dd class="col-7">
                <span *ngIf="project && project.contractFolderId " class="text-break">{{ getContractFolderId() }}</span>
                <!-- si no hay expedienteId se utiliza la propuesta -->
                <span *ngIf="!(project && project.contractFolderId)" class="text-break">{{ project.identifier }}</span>
            </dd>
            <!-- Descripción división -->
            <ng-container *ngIf="!division?.identifier.startsWith('0')">
                <!-- NIVEL 1 -->
                <dt class="col-5" *ngIf="division?.parent?.documentClass?.name">{{ division.parent.documentClass.name }}
                </dt>
                <dd class="col-7" *ngIf="division?.parent?.documentClas?.name">{{
                    truncateDivisionDescription(division.parent.name) }}</dd>
                <!-- NIVEL 1 -->
                <dt class="col-5" *ngIf="division?.documentClass?.name"> {{ division.documentClass.name }}: </dt>
                <dd class="col-7" *ngIf="division?.documentClass?.name && division?.name"> {{
                    truncateDivisionDescription(division.name) }}</dd>
                <dt class="col-5" *ngIf="division?.phase?.description">{{ 'DossierDetail.phase' | translate }}</dt>
                <dd class="col-7" *ngIf="division?.phase?.description"> {{ division.phase.description }} </dd>
            </ng-container>
            <!-- Expediente div 0  -->
            <ng-container *ngIf=" division && division.identifier.startsWith('0')">
                <dt class="col-5" *ngIf="division && division.name">{{ 'DossierDetail.contract.object'
                    | translate }}
                </dt>
                <dd class="col-7" *ngIf="project.title">{{ project.title}}</dd>
                <dd class="col-7" *ngIf="!project.title && project.abbreviatedTitle">{{ project.abbreviatedTitle }}</dd>
                <dd class="col-7" *ngIf="!project.title && !project.abbreviatedTitle">
                    {{truncateDivisionDescription(project.name)}}</dd>
            </ng-container>
            <ng-container *ngIf="project?.phase?.description && division && division.identifier.startsWith('0')">
                <dt class="col-5"> {{ 'DossierBasicInfo.phase.text' | translate }} </dt>
                <dd class="col-7"> {{ project.phase.description}} </dd>
            </ng-container>
            <dt class="col-5" *ngIf="project?.abbreviatedTitle">{{ 'DossierBasicInfo.title' | translate }}</dt>
            <dd class="col-7" *ngIf="project?.abbreviatedTitle">{{ project.abbreviatedTitle }}</dd>
            <dt class="col-5" *ngIf="project?.startYear"> {{ 'DossierBasicInfo.init.year' | translate }} </dt>
            <dd class="col-7" *ngIf="project?.startYear">{{ project.startYear }}</dd>
            <dt class="col-5" *ngIf="project?.modoTramitacion?.description"> {{ 'DossierBasicInfo.process' | translate
                }} </dt>
            <dd class="col-7" *ngIf="project?.modoTramitacion?.description"> {{ project.modoTramitacion.description }}
            </dd>
            <dt class="col-5" *ngIf="project?.claseExpId?.description"> {{ 'DossierBasicInfo.class' | translate }} </dt>
            <dd class="col-7" *ngIf="project?.claseExpId?.description"> {{ project.claseExpId.description }} </dd>
            <dt class="col-5" *ngIf="project?.presupSinIva"> {{ 'DossierBasicInfo.amount.tender.text' | translate }}
            </dt>
            <dd class="col-7" *ngIf="project?.presupSinIva"> {{ project.presupSinIva | currency: 'EUR' }} </dd>
            <dt class="col-5" *ngIf="project?.importePresup"> {{ 'DossierBasicInfo.amount.tender.taxes' | translate }}
            </dt>
            <dd class="col-7" *ngIf="project?.importePresup"> {{ project.importePresup | currency: 'EUR' }} </dd>
            <dt class="col-5" *ngIf="project?.valorEstimado"> {{ 'DossierBasicInfo.estimated.value' | translate }} </dt>
            <dd class="col-7" *ngIf="project?.valorEstimado"> {{ project.valorEstimado | currency: 'EUR' }} </dd>
            <dt class="col-5" *ngIf="project?.status?.situation"> {{ "DossierDetail.situation.label" | translate }}
            </dt>
            <dd class="col-7" *ngIf="project?.status?.situation"> {{ getSituationText() }} </dd>
            <dt class="col-5" *ngIf="project?.classification?.processingMode?.description"> {{ 'DossierDetail.process' |
                translate }} </dt>
            <dd class="col-7" *ngIf="project?.classification?.processingMode?.description"> {{
                project.classification.processingMode.description }} </dd>
            <dt class="col-5" *ngIf="project?.classification?.urgencyCode?.description"> {{ 'DossierDetail.class' |
                translate }} </dt>
            <dd class="col-7" *ngIf="project?.classification?.urgencyCode?.description"> {{
                project.classification.urgencyCode.description }} </dd>
            <dt class="col-5" *ngIf="project?.type?.description"> {{ 'DossierDetail.type.dossier' | translate }} </dt>
            <dd class="col-7" *ngIf="project?.type?.description"> {{ project.type.description }} </dd>
        </dl>
    </p-overlayPanel>
    <div>
        <span (mouseenter)="expTooltip.show($event, parentElement.nativeElement)">
            <span style="padding: 7px 0px;">
                <i class="fa  fa-lg " [ngClass]="getSituationClass()" aria-hidden="true"></i>&nbsp; </span>
            <!-- si hay expedienteId se utiliza -->
            <a (click)="openDossier()" *ngIf="project && project.contractFolderId && infoLink">{{ getContractFolderId()
                }}</a>
            <!-- si no hay expedienteId se utiliza la propuesta -->
            <a (click)="openDossier()" *ngIf="!(project && project.contractFolderId) && infoLink">{{ project.identifier
                }}</a>
        </span>
        <span *ngIf="project && project.contractFolderId && !infoLink" class="text-break">{{ getContractFolderId()
            }}</span>
        <!-- si no hay expedienteId se utiliza la propuesta -->
        <span *ngIf="!(project && project.contractFolderId) && !infoLink" class="text-break">{{ project.identifier
            }}</span>
        <h5 *ngIf="infoTitulo && project.title" class="text-truncate" class="card-title d-inline pl-2 text-break">{{
            project.title }}</h5>
        <h5 *ngIf="infoTitulo && !project.title" class="text-truncate" class="card-title d-inline pl-2 text-break">{{
            project.abbreviatedTitle }}</h5>
        <h5 *ngIf="infoTitulo && !project.title && !project.abbreviatedTitle" class="text-truncate"
            class="card-title d-inline pl-2  text-break">{{ truncateDivisionDescription(project.name) }}</h5>
    </div>
    <ng-container *ngIf="showDivisionInfo && division">
        <!-- NIVEL 1 -->
        <div *ngIf="division.parent && division.parent.identifier != '0'">
            <strong *ngIf="
          !division.parent.identifier.startsWith('0') &&
          division?.parent?.documentClass?.name
        ">{{ division.parent.documentClass.name }}: </strong> {{ truncateDivisionDescription(division.parent.name) }}
        </div>
        <!-- NIVEL 1 -->
        <div *ngIf="division && division.identifier != '0'">
            <strong *ngIf="!division.identifier.startsWith('0') && division.documentClass">{{
                division.documentClass.name }}: </strong>
            <span *ngIf="division.name">{{ truncateDivisionDescription(division.name) }}</span>
        </div>
    </ng-container>
</div>